import React from 'react';
import PropTypes from 'prop-types';
import { DisclaimerInfo } from 'site-modules/write-review/components/disclaimer-info/disclaimer-info';
import { SubmitButton } from 'site-modules/write-review/components/submit-button/submit-button';
import { AdditionalRatings } from 'site-modules/write-review/components/additional-ratings/additional-ratings';
import { AuthorInfo } from 'site-modules/write-review/components/author-info/author-info';
import { NextSteps } from 'site-modules/write-review/components/next-steps/next-steps';

export function MoreRatingsAndAuthorInfoConfirmed({ fieldRef, onSubmit, validate, isLoading = false }) {
  return (
    <div className="more-ratings-and-author-info-confirmed-step">
      <h1 className="heading-2 mb-0_5">Thank you</h1>
      <div className="mb-1_25 text-gray-darker">
        Your email has been confirmed. We review all submissions prior to publishing them, so it may take up to two
        business days for your review to appear.
      </div>
      <NextSteps />
      <hr className="mb-1_5 mt-0" />
      <div className="heading-3 mb-1_5">Tell us more (optional)</div>
      <AdditionalRatings fieldRef={fieldRef} validate={validate} />
      <AuthorInfo fieldRef={fieldRef} validate={validate} />
      <SubmitButton onClick={onSubmit} isLoading={isLoading} dataTrackingId="wr_submit_step_4" />
      <DisclaimerInfo />
    </div>
  );
}

MoreRatingsAndAuthorInfoConfirmed.propTypes = {
  validate: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  fieldRef: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};
